/**
 * Risk statuses that mean the risk no longer needs attention.
 *
 * Single source of truth for the "is this risk still open?" predicate. The
 * vocabulary is owned by the schema
 * (`apps/crm_events/schemas/properties/custom_signal_base_properties.yaml`);
 * every UI surface that hides closed risks — the record slideout Risks
 * section and the deal status view's risk flags — must derive from this list
 * so a new or renamed status is handled in one place.
 */
export const CLOSED_RISK_STATUSES = ['resolved', 'dismissed'] as const;

export type ClosedRiskStatus = (typeof CLOSED_RISK_STATUSES)[number];

/** True when `status` is one of the closed statuses. Undefined/null counts as open. */
export function isClosedRiskStatus(
  status: string | null | undefined
): status is ClosedRiskStatus {
  return (
    status !== null &&
    status !== undefined &&
    (CLOSED_RISK_STATUSES as readonly string[]).includes(status)
  );
}
